import {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

const OfficerLocationContext = createContext();

export const useOfficerLocation = () => useContext(OfficerLocationContext);

export const OfficerLocationProvider = ({
  officers = [],
  subscriptionServer,
  children,
}) => {
  const officersRef = useRef([]);
  const [officerList, setOfficerList] = useState([]);

  const updateOfficer = strData => {
    try {
      const data = JSON.parse(strData);
      const { employee_id, lat, lng, accuracy, source, ts } = data || {};

      if (!employee_id || !lat || !lng) return;

      const id = employee_id.toString();
      const updated = {
        id,
        lat: parseFloat(lat),
        lng: parseFloat(lng),
        accuracy: parseFloat(accuracy) || "",
        locationSource: source || "",
        locationUpdatedAt: ts,
      };

      officersRef.current = officersRef.current.map(o =>
        o.id.toString() === id ? { ...o, ...updated } : o
      );

      // For OfficerSearch
      setOfficerList([...officersRef.current]);
    } catch (e) {
      console.error("Failed to parse officer location update:", strData);
    }
  };

  useEffect(() => {
    if (!subscriptionServer || !officers?.length) return;

    officersRef.current = officers;

    officers.forEach(officer => {
      const officerId = officer.id.toString();
      subscriptionServer.subscribeToOfficerLocation(officerId, updateOfficer);
    });

    setOfficerList(officers); // initial state

    return () => {
      officers.forEach(officer => {
        const officerId = officer.id.toString();
        subscriptionServer.unsubscribeFromOfficerLocation(officerId);
      });
    };
  }, [subscriptionServer, officers]);

  return (
    <OfficerLocationContext.Provider
      value={{
        getOfficerById: id =>
          officersRef.current.find(o => o.id.toString() === id.toString()),
        officersRef,
        officerList,
      }}
    >
      {children}
    </OfficerLocationContext.Provider>
  );
};
